import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "overflow-hidden rounded-lg border border-slate-200 bg-white shadow-2xl" }
const _hoisted_2 = { class: "flex items-start justify-between gap-4 border-b border-slate-200 px-5 py-4" }
const _hoisted_3 = { class: "text-lg font-bold capitalize text-slate-900" }
const _hoisted_4 = { class: "max-h-[75vh] overflow-y-auto bg-white" }
const _hoisted_5 = { class: "divide-y divide-slate-100" }
const _hoisted_6 = { class: "grid grid-cols-1 gap-3 px-5 py-3 md:grid-cols-[170px_1fr] md:items-center" }
const _hoisted_7 = { class: "grid grid-cols-1 gap-3 px-5 py-3 md:grid-cols-[170px_1fr] md:items-center" }
const _hoisted_8 = { class: "grid grid-cols-1 gap-3 sm:grid-cols-3" }
const _hoisted_9 = ["value"]
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "grid grid-cols-1 gap-3 px-5 py-3 md:grid-cols-[170px_1fr] md:items-center" }
const _hoisted_12 = { class: "grid grid-cols-1 gap-3 px-5 py-3 md:grid-cols-[170px_1fr] md:items-start" }
const _hoisted_13 = { class: "grid grid-cols-1 gap-3 px-5 py-3 md:grid-cols-[170px_1fr] md:items-center" }
const _hoisted_14 = { class: "grid grid-cols-1 gap-3 px-5 py-3 md:grid-cols-[170px_1fr] md:items-start" }
const _hoisted_15 = { class: "space-y-3" }
const _hoisted_16 = { class: "flex flex-wrap gap-2" }
const _hoisted_17 = { class: "inline-flex items-center gap-2 rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-sm font-medium text-slate-700" }
const _hoisted_18 = { class: "inline-flex items-center gap-2 rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-sm font-medium text-slate-700" }
const _hoisted_19 = {
  key: 2,
  class: "text-xs text-slate-400"
}
const _hoisted_20 = {
  key: 3,
  class: "flex items-center gap-3"
}
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "flex flex-wrap items-center justify-between gap-3 border-t border-slate-100 bg-white px-6 py-4" }
const _hoisted_23 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppSelect = _resolveComponent("AppSelect")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[29] || (_cache[29] = _createElementVNode("div", { class: "fixed inset-0 z-[998] bg-slate-900/50 backdrop-blur-sm" }, null, -1)),
    _createElementVNode("div", {
      class: "fixed inset-0 z-[999] flex items-center justify-center p-4",
      onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
    }, [
      _createElementVNode("div", {
        ref: "modalContent",
        class: "w-full max-w-[760px]",
        onClick: _cache[17] || (_cache[17] = _withModifiers(() => {}, ["stop"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("form", {
            onSubmit: _cache[16] || (_cache[16] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"])),
            novalidate: ""
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", null, [
                _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.title), 1),
                _cache[19] || (_cache[19] = _createElementVNode("p", { class: "mt-1 text-sm text-slate-500" }, "Lengkapi informasi produk yang akan tampil di katalog.", -1))
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "rounded-lg p-1.5 text-slate-400 transition hover:bg-slate-100 hover:text-slate-700",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
              }, [...(_cache[20] || (_cache[20] = [
                _createElementVNode("svg", {
                  class: "h-5 w-5",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  stroke: "currentColor"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M6 18L18 6M6 6l12 12"
                  })
                ], -1)
              ]))])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[21] || (_cache[21] = _createElementVNode("div", null, [
                    _createElementVNode("label", { class: "text-sm font-semibold text-slate-900" }, [
                      _createTextVNode("Nama Produk "),
                      _createElementVNode("span", { class: "text-red-500" }, "*")
                    ]),
                    _createElementVNode("p", { class: "mt-0.5 text-xs text-slate-400" }, "Nama merchandise yang tampil di katalog.")
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.data.name) = $event)),
                    type: "text",
                    required: "",
                    class: "block w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-[#8c8c94]/20",
                    placeholder: "mis. Kaos IOM ITB"
                  }, null, 512), [
                    [_vModelText, _ctx.formData.data.name]
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _cache[22] || (_cache[22] = _createElementVNode("div", null, [
                    _createElementVNode("label", { class: "text-sm font-semibold text-slate-900" }, [
                      _createTextVNode("Stok & Harga "),
                      _createElementVNode("span", { class: "text-red-500" }, "*")
                    ]),
                    _createElementVNode("p", { class: "mt-0.5 text-xs text-slate-400" }, "Jumlah stok, harga jual, dan HPP internal.")
                  ], -1)),
                  _createElementVNode("div", _hoisted_8, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.data.stock) = $event)),
                      type: "number",
                      min: "0",
                      required: "",
                      class: "block w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-[#8c8c94]/20",
                      placeholder: "Stok"
                    }, null, 512), [
                      [_vModelText, _ctx.formData.data.stock]
                    ]),
                    _createElementVNode("input", {
                      value: _ctx.formatCurrencyInput(_ctx.formData.data.price),
                      type: "text",
                      inputmode: "numeric",
                      required: "",
                      class: "block w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-[#8c8c94]/20",
                      placeholder: "Rp 0",
                      onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onPriceInput && _ctx.onPriceInput(...args)))
                    }, null, 40, _hoisted_9),
                    _createElementVNode("input", {
                      value: _ctx.formatCurrencyInput(_ctx.formData.data.hpp),
                      type: "text",
                      inputmode: "numeric",
                      class: "block w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-[#8c8c94]/20",
                      placeholder: "HPP Rp 0",
                      onInput: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onHppInput && _ctx.onHppInput(...args)))
                    }, null, 40, _hoisted_10)
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _cache[23] || (_cache[23] = _createElementVNode("div", null, [
                    _createElementVNode("label", { class: "text-sm font-semibold text-slate-900" }, "Kategori"),
                    _createElementVNode("p", { class: "mt-0.5 text-xs text-slate-400" }, "Kelompok produk untuk filter katalog.")
                  ], -1)),
                  _createElementVNode("div", null, [
                    _createVNode(_component_AppSelect, {
                      "model-value": _ctx.selectedKategori,
                      options: _ctx.kategoriSelectOptions,
                      "button-class": "bg-white text-slate-800",
                      onChange: _ctx.onKategoriChange
                    }, null, 8, ["model-value", "options", "onChange"]),
                    (_ctx.showNewKategori)
                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 0,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newKategoriInput) = $event)),
                          type: "text",
                          placeholder: "Nama kategori baru",
                          class: "mt-2 block w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-[#8c8c94]/20",
                          onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.updateValue({ key: 'kategori', value: _ctx.newKategoriInput })))
                        }, null, 544)), [
                          [_vModelText, _ctx.newKategoriInput]
                        ])
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _cache[24] || (_cache[24] = _createElementVNode("div", { class: "md:pt-2" }, [
                    _createElementVNode("label", { class: "text-sm font-semibold text-slate-900" }, [
                      _createTextVNode("Deskripsi "),
                      _createElementVNode("span", { class: "text-red-500" }, "*")
                    ]),
                    _createElementVNode("p", { class: "mt-0.5 text-xs text-slate-400" }, "Ringkasan produk untuk halaman publik.")
                  ], -1)),
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.data.description) = $event)),
                    rows: "3",
                    required: "",
                    class: "block w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-[#8c8c94]/20",
                    placeholder: "Deskripsi singkat produk..."
                  }, null, 512), [
                    [_vModelText, _ctx.formData.data.description]
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _cache[25] || (_cache[25] = _createElementVNode("div", null, [
                    _createElementVNode("label", { class: "text-sm font-semibold text-slate-900" }, "Link Pembelian"),
                    _createElementVNode("p", { class: "mt-0.5 text-xs text-slate-400" }, "Gunakan link ITB Press bila tersedia.")
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.data.link) = $event)),
                    type: "url",
                    class: "block w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-[#8c8c94]/20",
                    placeholder: "https://itbpress.id/..."
                  }, null, 512), [
                    [_vModelText, _ctx.formData.data.link]
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _cache[28] || (_cache[28] = _createElementVNode("div", { class: "md:pt-2" }, [
                    _createElementVNode("label", { class: "text-sm font-semibold text-slate-900" }, "Gambar Produk"),
                    _createElementVNode("p", { class: "mt-0.5 text-xs text-slate-400" }, "Masukkan URL gambar atau unggah JPG/PNG maksimal 5 MB.")
                  ], -1)),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("label", _hoisted_17, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.imageMode) = $event)),
                          type: "radio",
                          value: "url",
                          class: "text-blue-700 focus:ring-blue-500"
                        }, null, 512), [
                          [_vModelRadio, _ctx.imageMode]
                        ]),
                        _cache[26] || (_cache[26] = _createTextVNode(" URL ", -1))
                      ]),
                      _createElementVNode("label", _hoisted_18, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.imageMode) = $event)),
                          type: "radio",
                          value: "upload",
                          class: "text-blue-700 focus:ring-blue-500"
                        }, null, 512), [
                          [_vModelRadio, _ctx.imageMode]
                        ]),
                        _cache[27] || (_cache[27] = _createTextVNode(" Upload ", -1))
                      ])
                    ]),
                    (_ctx.imageMode === 'url')
                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 0,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.imageUrl) = $event)),
                          type: "url",
                          class: "block w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-[#8c8c94]/20",
                          placeholder: "https://...",
                          onInput: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.onImageUrlInput && _ctx.onImageUrlInput(...args)))
                        }, null, 544)), [
                          [_vModelText, _ctx.imageUrl]
                        ])
                      : (_openBlock(), _createElementBlock("input", {
                          key: 1,
                          type: "file",
                          accept: "image/jpeg,image/png",
                          class: "block w-full text-sm text-slate-600 file:mr-3 file:rounded-lg file:border-0 file:bg-blue-50 file:px-3 file:py-2 file:text-sm file:font-semibold file:text-blue-700 hover:file:bg-blue-100",
                          onChange: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.onImageFileChange && _ctx.onImageFileChange(...args)))
                        }, null, 32)),
                    (_ctx.imageMode === 'upload')
                      ? (_openBlock(), _createElementBlock("p", _hoisted_19, "Format JPG/PNG, maksimal 5 MB."))
                      : _createCommentVNode("", true),
                    (_ctx.imagePreview)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _createElementVNode("img", {
                            src: _ctx.imagePreview,
                            alt: "Preview produk",
                            class: "h-16 w-16 rounded-lg border border-slate-200 object-cover"
                          }, null, 8, _hoisted_21),
                          _createElementVNode("button", {
                            type: "button",
                            class: "rounded-lg bg-red-50 px-3 py-1.5 text-sm font-semibold text-red-600 hover:bg-red-100",
                            onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.removeImage && _ctx.removeImage(...args)))
                          }, " Hapus Gambar ")
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
                class: "rounded-lg border border-slate-200 bg-white px-4 py-2 text-sm font-medium text-slate-600 transition hover:bg-slate-50 focus:outline-none"
              }, " Batal "),
              _createElementVNode("button", {
                type: "submit",
                disabled: _ctx.isLoading,
                class: "rounded-lg bg-blue-800 px-5 py-2 text-sm font-semibold text-white shadow-sm transition hover:bg-blue-700 focus:outline-none disabled:cursor-not-allowed disabled:opacity-60"
              }, _toDisplayString(_ctx.isLoading ? 'Menyimpan...' : 'Simpan'), 9, _hoisted_23)
            ])
          ], 32)
        ])
      ], 512)
    ])
  ], 64))
}